import { render, staticRenderFns } from "./SysDialogFullScreen.vue?vue&type=template&id=efa5f0c8&scoped=true"
import script from "./SysDialogFullScreen.vue?vue&type=script&lang=js"
export * from "./SysDialogFullScreen.vue?vue&type=script&lang=js"
import style0 from "./SysDialogFullScreen.vue?vue&type=style&index=0&id=efa5f0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa5f0c8",
  null
  
)

export default component.exports